<template>
    <div class="dd-calendar">
        <div class="d-flex justify-content-between col-3">
            <!--<div class="">-->
            <!--justify-content-between-->
            <!--<label :class="['my-auto pb-2', { 'Required': isRequired }]" style="padding-left:20px;">
            {{ label }}
        </label>-->
            <div>

                <slot class=""></slot>
            </div>
            <div>
                <v-row align="center" justify="center" no-gutters>
                    <v-col md="4" class="pb-2">
                        <span :class="{ 'primary--text': !isGregorianInternal }">هجري</span>
                    </v-col>
                    <v-col md="4">
                        <n-switch :toggle="isGregorian" :modelValue="isGregorianInternal" @update:modelValue="isGregorianInternal = $event" flat inset dense hide-details class="dd-switch-aligned"></n-switch>
                    </v-col>

                    <v-col md="4" class="pb-2">
                        <span :class="{ 'primary--text': isGregorianInternal }">ميلادي</span>
                    </v-col>
                </v-row>
            </div>
            <!--</div>-->
        </div>
        <div v-if="showSetToday">
            <v-checkbox v-model="setToday" @change="toggleToday" label="تعيين تاريخ اليوم" />
        </div>
        <!--<div class="col-3">

    </div>-->
        <div class="row d-flex justify-content-start">
            <div class="d-flex justify-content-start align-items-center">
                <label style="padding-left: 25px;">من: </label>
                <div class="col-4">
                    <date-picker-component ref="dateFromRef"
                                           :key="'dateFrom'+_uid"
                                           :maxDate="maxDate"
                                           :futureYearsCount="futureYearsCount"
                                           :minDate="minDateInternal"
                                           :isRequired="true"
                                           label=" التاريخ من "
                                           :isGregorian="isGregorianInternal"
                                           :selectedDateCal="selectedDateFrom"
                                           @dateChanged="onDateFromChanged" />
                </div>
                <label style="padding-left: 25px; padding-right: 70px;">  الى: </label>
                <div class="col-4">
                    <date-picker-component ref="dateToRef"
                                           :key="'dateTo'+_uid"
                                           :maxDate="maxDate"
                                           :futureYearsCount="futureYearsCount"
                                           :minDate="minDateToInternal"
                                           :isRequired="true"
                                           label=" التاريخ الى "
                                           :isGregorian="isGregorianInternal"
                                           :selectedDateCal="selectedDateTo"
                                           @dateChanged="onDateToChanged" />
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Watch, Prop, Component, Vue } from "vue-property-decorator";
    import moment from 'moment';
    import NSwitch from '@/components/calender/nSwitchcomponent.vue';
    import DatePickerComponent from '@/components/calender/datePickerComponent.vue';
    import { DDCalendarDate, DateRangeModel } from '@/models/common';
    //@ts-ignore
    import momenthijri from 'moment-hijri';

    interface SelectedMonth {
        name: string;
        value: number;
    }

    @Component({
        components: {
            NSwitch,
            DatePickerComponent
        },
    })
    export default class datePickerRangeComponent extends Vue {
        @Prop({ default: '' }) label!: string;
        @Prop({ default: 100 }) yearsCount!: number;
        @Prop({ default: 0 }) futureYearsCount!: number;
        @Prop({ default: false }) isGregorian!: boolean;
        @Prop({ default: '' }) date!: string;
        @Prop({ default: false }) isRequired!: boolean;
        @Prop({ default: '' }) maxDate!: string;
        @Prop({ default: '' }) minDateHijri!: string;
        @Prop({ default: '' }) minDateGregorian!: string;
        @Prop({ default: -1 }) index!: number;
        @Prop({ default: '' }) selectedDate!: string;
        @Prop({ default: null }) selectedDateRang!: DateRangeModel;
        @Prop({ default: false }) showSetToday!: boolean;

        isGregorianInternal = false;
        isCleared = false;
        dateRange = {} as DateRangeModel;
        defaultMinDateHijriInternal = "1440-01-01";
        defaultMinDateGregorianInternal = "2021-01-01";
        minDateInternal = '';
        minDateToInternal = '';
        setToday = false; // Checkbox state
        selectedDateFrom = null as DDCalendarDate | null;
        selectedDateTo = null as DDCalendarDate | null;

        @Watch('isGregorianInternal')
        OnIsGregorianInternalChanged() {
            this.setMinDates();
            this.clear();
            this.selectedDateFrom = null;
            this.selectedDateTo = null;
        }
        onDateFromChanged(date: any): void {
            this.dateRange.dateFrom = date;
            if (this.dateRange?.dateTo?.hijriDate < this.dateRange?.dateFrom?.hijriDate) {
                (this.$refs.dateToRef as any).clear();
            }
            this.$emit('dateChanged', this.dateRange);
            this.setMinDateToInternal();
            (this.$refs.dateToRef as any).resetYears();
        }
        setMinDateToInternal() {
            if (this.isGregorianInternal === true) {
                if (this.dateRange?.dateFrom != undefined && this.dateRange?.dateFrom != null && this.dateRange?.dateFrom?.gregDate != '') {
                    this.minDateToInternal = this.dateRange?.dateFrom?.gregDate;
                }
                else {
                    this.minDateToInternal = this.defaultMinDateGregorianInternal;
                }
            }
            else {
                if (this.dateRange?.dateFrom != undefined && this.dateRange?.dateFrom != null && this.dateRange?.dateFrom?.hijriDate != '') {
                    this.minDateToInternal = this.dateRange?.dateFrom?.hijriDate;
                }
                else {
                    this.minDateToInternal = this.defaultMinDateHijriInternal;
                }
            }
        }
        setMinDates() {
            this.setDefaultMinDatesInternal();
            if (this.isGregorianInternal === true) {
                this.minDateInternal = this.defaultMinDateGregorianInternal;
            }
            else {
                this.minDateInternal = this.defaultMinDateHijriInternal;
            }
            this.setMinDateToInternal();
        }
        setDefaultMinDatesInternal() {
            if (this.minDateGregorian != '') {
                this.defaultMinDateGregorianInternal = this.minDateGregorian;
            }
            if (this.minDateHijri != '') {
                this.defaultMinDateHijriInternal = this.minDateHijri;
            }
        }
        onDateToChanged(date: any): void {
            this.dateRange.dateTo = date;
            this.$emit('dateChanged', this.dateRange);
        }
        mounted() {
            this.setMinDates();
            this.isGregorianInternal = this.isGregorian;
            if (this.selectedDateRang) {
                if (this.selectedDateRang.dateFrom.date) {
                    this.selectedDateFrom = this.selectedDateRang.dateFrom;
                    this.isGregorianInternal = this.selectedDateRang.dateFrom.isGregorian;
                }
                if (this.selectedDateRang.dateTo.date) {
                    this.selectedDateTo = this.selectedDateRang.dateTo;
                    this.isGregorianInternal = this.selectedDateRang.dateTo.isGregorian;
                }
            }
        }
        clear() {
            this.setMinDateToInternal();
            this.clearDateFrom();
            this.clearDateTo();
            this.isCleared = true;
            this.setToday = false;
        }
        clearDateFrom() {
            if (this.dateRange.dateFrom != null && this.dateRange.dateFrom != undefined) {
                this.dateRange.dateFrom.gregDate = '';
                this.dateRange.dateFrom.hijriDate = '';
            }
            this.selectedDateFrom = null;
            (this.$refs.dateFromRef as any).clear();
            (this.$refs.dateToRef as any).resetYears();
        }
        clearDateTo() {
            this.setMinDateToInternal();
            if (this.dateRange.dateTo != null && this.dateRange.dateTo != undefined) {
                this.dateRange.dateTo.gregDate = '';
                this.dateRange.dateTo.hijriDate = '';
            }
            this.selectedDateTo = null;
            (this.$refs.dateToRef as any).clear();
        }
        toggleToday(): void {
            if (this.setToday) {
                (this.$refs.dateFromRef as any).setToday();
                (this.$refs.dateToRef as any).setToday();
            } else {
                this.clear();
            }
        }
        calendarTypeChange() {
            this.clear();
        }
    }
</script>

<style lang="scss" scoped>
    .dd-calendar .v-input__control .v-input__icon--append i.mdi {
        color: var(--v-primary-base);
    }

    .wide-input div[role='combobox'] {
        padding: 0 8px !important;
    }

    .dd-calendar .dd-switch-aligned {
        margin-top: 5px;
    }

    .dd-calendar .rounded-0 .v-input__control .v-input__slot > fieldset {
        border-color: #e4e5e6;
    }

    .dd-calendar .v-input__append-inner {
        margin-top: 14px !important;
        cursor: pointer;
    }

    .dd-calendar .v-select__slot .v-label {
        margin-top: 5px !important;
    }

    .v-field__append-inner {
        cursor: pointer !important;
    }

    .v-selection-control--density-default {
        --v-selection-control-size: -1px !important;
    }

    .mdi-chevron-down {
        display: none !important;
    }
    .v-input--selection-controls {
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
</style>



